
import { Timestamp } from '@firebase/firestore-types';
import { TimestampAudit } from '@/types/app';
import { computed, defineComponent, PropType } from 'vue';

export default defineComponent({
  name: 'Timestamp',
  props: {
    timestamp: {
      type: Object as PropType<TimestampAudit | Timestamp>,
      default: () => ({})
    }
  },
  setup(props) {
    const timestampAudit = computed(() => {
      if (Object.getOwnPropertyNames(props.timestamp).includes('timestamp')) {
        return props.timestamp as TimestampAudit;
      }

      return undefined;
    });

    const firebaseTimestamp = computed(() => {
      if (Object.getOwnPropertyNames(props.timestamp).includes('nanoseconds')) {
        return props.timestamp as Timestamp;
      }

      return undefined;
    });

    return {
      timestampAudit,
      firebaseTimestamp
    };
  }
});
